export enum TableAction {
    CREATE = 'create',     
    REFRESH = 'refresh',
    EXPORT = 'export',
    IMPORT = 'import', 
  }